import { useEffect, useState, useContext, createContext, ReactNode } from "react";
import FullLoader from "../components/FullLoader/FullLoader";
import { onIdTokenChanged, User } from "firebase/auth";
import { auth } from "../firebase/firebase";

interface Props {
  children: ReactNode;
}

const AuthContext = createContext<{ user: User | null; loading: boolean; }>({
  user: null,
  loading: true
});

export const AuthProvider = ({ children }: Props) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState<Boolean>(true);

  useEffect(() => {
    const uns = onIdTokenChanged(auth, (user: User | null) => {
      setUser(user);
      setLoading(false);
    });

    return uns;
  }, []);

  if (loading) return <FullLoader />;

  return <AuthContext.Provider value={{ user, loading }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);